import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { type BillAction } from '@/types/bill';
import { Gavel, MoreVertical } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const BILL_ACTIONS = [
  { 
    value: 'LegislativeReview' as BillAction, 
    label: 'AI Legislative Review', 
    icon: Gavel,
    description: 'Generate a legislative review using AI'
  },
  // {
  //   value: 'LegislativeReviewWithRefinement' as BillAction,
  //   label: 'AI Legislative Review with Refinement',
  //   icon: Sparkles,
  //   description: 'Generate a refined legislative review using AI'
  // },
  // {
  //   value: 'OppositionTestimony' as BillAction,
  //   label: 'AI Opposition Testimony',
  //   icon: ThumbsDown,
  //   description: 'Generate opposition testimony using AI'
  // },
  // {
  //   value: 'SupportTestimony' as BillAction,
  //   label: 'AI Support Testimony',
  //   icon: ThumbsUp,
  //   description: 'Generate support testimony using AI'
  // }
];

interface BillActionDropdownProps {
  onAction: (action: BillAction) => void;
  disabled?: boolean;
}

export function BillActionDropdown({ onAction, disabled = false }: BillActionDropdownProps) {
  return (
    <DropdownMenu>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="px-2 w-8 h-8" disabled={disabled}>
                  <MoreVertical className="h-4 w-4" />
                  <span className="sr-only">Open AI actions menu</span>
                </Button>
              </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent>
            {disabled ? "Full text required for AI actions" : "AI Actions"}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent
        align="end"
        className="w-64 bg-white dark:bg-gray-900 shadow-lg border border-gray-200 dark:border-gray-800 rounded-md"
      >
        {BILL_ACTIONS.map((action) => (
          <DropdownMenuItem
            key={action.value}
            className="flex items-start gap-3 px-4 py-3 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 focus:bg-gray-100 dark:focus:bg-gray-800 outline-none transition-colors"
            onSelect={() => onAction(action.value)}
          >
            <div className="mt-1">
              <action.icon className="h-4 w-4 text-gray-600 dark:text-gray-400" />
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="font-medium text-sm text-gray-900 dark:text-gray-100">
                {action.label}
              </span>
              <span className="text-xs text-gray-500 dark:text-gray-400 leading-snug">
                {action.description}
              </span>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}